import BaseFilter from './BaseFilter';
import BaseProperties from './BaseProperties';
import _ from '../../../libs/lodash';
import ganttFilterHelper from '../../../helpers/gantt_filter';
import routerHelper from '../../../helpers/router';
import globalStore from '$$store/main';
import app from '../../../app';

const _self = null;

class ListviewFilter extends BaseFilter {
  static filterByType() {
    if (!_self) {
      this._self = new ListviewFilter('list');
      this.filteringOnInit = false;
    }

    return this._self;
  }

  get _emptyState() {
    return {
      type: '',
      status: '',
      assignee: '',
      priority: '',
      reporter: '',
      rangeDate: {
        start: '',
        end: '',
      },
      startDate: {
        start: '',
        end: '',
      },
      endDate: {
        start: '',
        end: '',
      },
      creationDate: {
        start: '',
        end: '',
      },
      text: '',
    };
  }

  get myIncompleteTasksState() {
    const resourceData = globalStore.getters['resourcesModel/getResourceByUserId'](user.id);

    return {
      ...this._emptyState,
      status: ['1', '2'],
      assignee: [resourceData.id],
    };
  }

  config() {
    const conf = [
      BaseProperties.taskName('text'),
      BaseProperties.projects('ganttId'),
      BaseProperties.taskTypes(),
      BaseProperties.assigneeByGanttIDs('assignee', this.ganttIDs),
      BaseProperties.statuses(),
      BaseProperties.priority(),
      BaseProperties.reporter('reporter'),
      BaseProperties.dateRange(),
      BaseProperties.startDate(),
      BaseProperties.endDate(),
      BaseProperties.creationDate(),
      BaseProperties.overdue(),
    ];

    if (routerHelper.isSingleProjectRoute()) {
      conf.splice(1, 1);
    }

    return conf;
  }

  init() {
    super.init();
    this.resetIfnotFoundTasks = false;

    if (!this.isActiveFilter && routerHelper.isListViewRoute() ) {
      const state = _.cloneDeep(this.myIncompleteTasksState);

      this.setFilterState(state, true);
    } else if (!this.isActiveFilter && (routerHelper.isProjectList() || routerHelper.isMultiviewList())) {
      this.setFilterState(this._emptyState);
    }
  }

  filterData() {
    const tasks = globalStore.getters['listView/totalTasks'];

    if (!tasks) return;
    let filtredTasks = [];

    if (this.isActiveFilter) {
      const filter = ganttFilterHelper.getFilter(window.gantt, {
        options: this.filterState,
        value: this.filterState.text || '',
      }, null);

      filtredTasks = tasks.filter(t => filter(t));
      if (!filtredTasks.length) {
        app.trigger('filter:tasks:not:found');
      }
    } else {
      filtredTasks = tasks;
    }

    globalStore.commit('listView/setFiltredTasks', filtredTasks);

    this.updateDataOnHeader(filtredTasks.length);
    this.appliedFirstFiltration = true;

    return filtredTasks;
  }

  myIncompleteTasks() {
    this.changeFilterState(this.myIncompleteTasksState);
  }

  changeFilterState(filterState) {
    this.setFilterState(filterState);
    this.filterData();
  }

  refreshFilter() {
    this.changeFilterState(this.filterState);
  }

  selectSavedFilter(filter) {
    this.changeFilter(filter.id, filter.value);
    this.filterData();
  }

  resetFilter() {
    this.setFilterState(this._emptyState);
    this.filterData();
  }

  updateDataOnHeader(tasks_count) {
    globalStore.commit('headerView/setListTasksCount', tasks_count);
    globalStore.commit('headerView/setMyTasksFilter', this.isMyIncompleteTaskFilter());
  }

  isMyIncompleteTaskFilter() {
    if (!this.filterState.assignee || !this.filterState.status) return false;
    if (this.filterState.assignee.length !== 1 || this.filterState.status.length !== 2) return false;

    const statuses = this.filterState.status ? this.filterState.status.join() : '';
    const resourceData = globalStore.getters['resourcesModel/getResourceByUserId'](user.id);

    if (resourceData.id === this.filterState.assignee[0] && (statuses === '1,2' || statuses === '2,1')) {
      if (gantt.isDeepEmpty(_.omit(this.filterState, ['assignee', 'status']))) return true;
    }

    return false;
  }
}

export default ListviewFilter;
